// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const illumise: PokeData = {
  "id": 314,
  "name": "illumise",
  "height": 6,
  "weight": 177,
  "base_experience": 151,
  "types": [
    PokeType.BUG
  ],
  "api_moves": [
    "tackle",
    "quick-attack",
    "charm",
    "encore",
    "sweet-scent",
    "moonlight",
    "flatter",
    "helping-hand",
    "wish",
    "covet",
    "bug-buzz",
    "zen-headbutt",
    "struggle-bug",
    "play-rough",
    "play-nice",
    "infestation"
  ],
  "moves": [
    "tackle",
    "quick-attack",
    "moonlight",
    "flatter",
    "bug-buzz",
    "zen-headbutt",
    "play-rough",
    "leech-steal",
    "string-shot",
    "bug-bite",
    "pin-rush",
    "heal-order",
    "signal-spam"
  ],
  "evolution_chain": {
    "id": 157,
    "item": null,
    "species": [
      {
        "name": "illumise",
        "order": 340,
        "types": [
          PokeType.BUG
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 126,
    "speed": 148,
    "ability_power": 127
  },
  "stat_changes": [],
  "catch_rate": 150,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
